export default "__VITE_ASSET__DN30JHuv__"